@if (flow) {
  <div>
    <div class="example-box">
      This is super experimental - please send feedback.
    </div>
    @if (error) {
      <div class="example-box">
        {{error}}
      </div>
    }
    <!-- <kendo-toolbar>
    <kendo-toolbar-button [text]="'Save'" (click)="onSaveClick()"></kendo-toolbar-button>
  </kendo-toolbar> -->
  Select an action: <br />
  <kendo-treeview kendoTreeViewExpandable kendoTreeViewSelectable [nodes]="data" textField="text" [children]="fetchChildren" [hasChildren]="hasChildren" (selectionChange)='this.selectAction($event)' #actionsTree>
  </kendo-treeview>
  <hr />
  Change Name: <br />
  <input kendoTextBox [(ngModel)]="newName" />
  <div style='margin-top:10px;'>
    <button kendoButton (click)="this.rename()" themeColor="primary">Change Action Name</button>
    <button kendoButton (click)="this.onSaveClick()" >Save &amp; Close</button>
  </div>
</div>
}
